<template>
  <b-navbar toggleable="lg" type="light" fixed="top" class="cb-navbar">
    <div class="container">
      <b-navbar-brand :to="{ name: 'colorful-bytes-home' }">
        <img src="@/assets/img/logo_cropped_320.webp" class="d-inline-block align-top logo" alt="Colorful Bytes Logo" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <div class="navbar-nav ml-auto">
          <b-nav-item :to="{ name: 'colorful-bytes-home' }" exact-active-class="active">{{ $t("general.home") }}</b-nav-item>
          <b-nav-item :to="{ name: 'stage-guide-home' }" active-class="active">{{ $t("stage-guide.title") }}</b-nav-item>
          <b-nav-item :to="{ name: 'coaching-home' }" active-class="active">{{ $t("coaching.title") }}</b-nav-item>
          <li class="nav-item">
            <a class="nav-link" :href="supportLink" target="_blank">{{ $t("general.support") }}</a>
          </li>
          <b-nav-item :to="{ name: 'colorful-bytes-contact' }" active-class="active">{{ $t("general.contact") }}</b-nav-item>
          <!--
          <b-nav-item :to="{ name: 'colorful-bytes-team' }" active-class="active">{{ $t("general.team") }}</b-nav-item>
          -->
          <b-nav-item :to="{ name: 'colorful-bytes-home', hash: '#footer' }" active-class="active">{{ $t("general.imprint") }}</b-nav-item>
          <b-nav-item :to="{ name: 'colorful-bytes-data-privacy' }" active-class="active">{{ $t("general.dataPrivacy") }}</b-nav-item>
          <locale-switcher />
        </div>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import LocaleSwitcher from "@/components/general/LocaleSwitcher";

export default {
  computed: {
    locale() {
      return this.$i18n.locale.toLowerCase();
    },
    supportLink() {
      let locale = this.locale;
      if (locale === "fr") {
        locale = "en";
      }
      return `https://support.colorful-bytes.com/${locale}/support/`;
    }
  },
  components: {
    LocaleSwitcher
  }
};
</script>

<style lang="scss" scoped>
nav {
  background-color: white;
}

.logo {
  height: $navbar-logo-height;
  margin-top: -5px;
  margin-bottom: -5px;
}
</style>
